/**
 * apps/app/lib/profile-fields.ts
 *
 * Shared constants/helpers for the personal-info screens (profile.tsx) and
 * settings.tsx.
 */

export const RISK_OPTIONS = [
  { value: 'conservative', label: 'Conservative' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'aggressive', label: 'Aggressive' },
] as const;

export const FILING_OPTIONS = [
  { value: 'single', label: 'Single' },
  { value: 'married_filing_jointly', label: 'Married Filing Jointly' },
] as const;

const RISK_THRESHOLDS = {
  conservative: 0.95,
  moderate: 0.85,
  aggressive: 0.75,
} as const;

export function getThresholdForRiskTolerance(value: string) {
  return RISK_THRESHOLDS[value as keyof typeof RISK_THRESHOLDS] ?? RISK_THRESHOLDS.moderate;
}

export function parseNonNegativeCurrencyInput(value: string) {
  const normalized = value.replace(/[$,\s]/g, '');
  if (!normalized) return 0;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
}

export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA',
  'KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT',
  'VA','WA','WV','WI','WY','DC',
] as const;

export function formatFilingStatus(value: string | null | undefined) {
  switch (value) {
    case 'married_filing_jointly':
      return 'Married Filing Jointly';
    case 'single':
      return 'Single';
    default:
      return '—';
  }
}
